import { render } from "./VersionUpdates.vue?vue&type=template&id=10afef69&scoped=true"
import script from "./VersionUpdates.vue?vue&type=script&lang=js"
export * from "./VersionUpdates.vue?vue&type=script&lang=js"

import "./VersionUpdates.vue?vue&type=style&index=0&id=10afef69&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10afef69"]])

export default __exports__